import React, { useEffect } from "react";
import LoadingIndicator from "../components/loadingIndicator/loadingIndicator";

export default function Home() {
  return <LoadingIndicator />;
}
